export const SCROLL = 'scroll';
export const SCROLL_UPDATE = 'ScrollManager:update';
export const SCROLL_TOGGLE = 'ScrollManager:toggle';
export const WHEEL_DIRECTION = 'WheelManager:direction';
export const RESIZE = 'resize';
export const BREAKPOINT = 'ResizeManager:breakpoint';
export const RESIZE_UPDATE = 'ResizeManager:update';
export const MENU_TOGGLE = 'menu:toggle';
export const LOAD = 'load';
export const DOM_CONTENT_LOADED = 'DOMContentLoaded';
export const VIEW_READY = 'View:Ready';
export const DIALOG_TOGGLE = 'Dialog:toggle';
export const MODAL_TOGGLE = 'Modal:toggle';
export const REVEALS = 'reveals';
